module.exports = "../fonts/steps.svg";


//////////////////
// WEBPACK FOOTER
// ./src/YouTravel/images/steps.svg
// module id = 399
// module chunks = 0